import { ProductTypeKey } from 'shared/types/product/Product';
import { Category } from 'types/entity/category';
import { getGlassBuilderUrl } from './glassBuilder';
import { getRailingBuilderUrl } from './railingBuilder';
import { getTreadBuilderUrl } from './treadBuilder';

export type ProductBuilderKind = 'tread' | 'railing' | 'glass';

export interface ProductBuilder {
  kind: ProductBuilderKind;
  /** The builder's name as the site calls it ("Tread Builder"), for copy that names it. */
  name: string;
  href: string;
}

const BUILDER_NAMES: Record<ProductBuilderKind, string> = {
  tread: 'Tread Builder',
  railing: 'Railing Builder',
  glass: 'Glass Panel Builder',
};

/**
 * The one online builder that produces this product, or null. Treads resolve by category and
 * name, posts and glass panels by product type; a product never belongs to more than one. Shared by
 * the buy box's builder link and the variant section's escape hatch so they can't disagree.
 */
export const getProductBuilder = (product: {
  categories?: Category[];
  name?: string;
  type?: ProductTypeKey;
}): ProductBuilder | null => {
  const candidates: Array<[ProductBuilderKind, string | null]> = [
    ['tread', getTreadBuilderUrl(product.categories, product.name)],
    ['railing', getRailingBuilderUrl(product.type)],
    ['glass', getGlassBuilderUrl(product.type)],
  ];
  const found = candidates.find((candidate): candidate is [ProductBuilderKind, string] => Boolean(candidate[1]));
  return found ? { kind: found[0], name: BUILDER_NAMES[found[0]], href: found[1] } : null;
};
